export default __webpack_public_path__ + "f12d29a855ce6d98c025690b98c53cee.png";